/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Pressuredefect1Inputs */



/**
* | output |
* | --- |
* | "Pressure fault" |
*
* @param {Ahu_History_Key_Pressuredefect1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_pressuredefect1 = /** @type {((inputs?: Ahu_History_Key_Pressuredefect1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Pressuredefect1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Pressure fault")
	return /** @type {LocalizedString} */ ("Défaut de pression")
});
export { ahu_history_key_pressuredefect1 as "ahu_history_key_pressureDefect" }